firebird.controller('meetingNotStartedCtrl', [
    '$scope',
    '$window',
    '$stateParams',
    '$timeout',
    '$q',
    'logService',
    'meetingService',
    'meetingAPIService',
    'helperService',
    'attendeeService',
    'audioFileService',
    'timeZoneService',
    'brandingService',
    'cookieService',
    'localizationService',
    'analyticsWrapperService',
    'authService',
    'routerService',
    function (
        $scope,
        $window,
        $stateParams,
        $timeout,
        $q,
        logService,
        meetingService,
        meetingAPIService,
        helperService,
        attendeeService,
        audioFileService,
        timeZoneService,
        brandingService,
        cookieService,
        localizationService,
        analyticsWrapperService,
        authService,
        routerService
    ) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'meetingNotStartedCtrl');
        const maxJoinBeforeHostAttemptCount = 5;
        self.joinBeforeHostAttemptCounter = 0;

        self.title = '';
        self.date = '';
        self.startTime = '';
        self.endTime = '';
        self.upcomingEventTimes = [];
        self.timeZone = ''; //This is for controller use only
        self.timeZoneShort = '';
        self.timeZoneSelected = ''; //This is bound to Select Options
        self.creationTimezone = '';
        self.timeZoneList = [];
        self.meetingURL = '';
        self.getTimeZone = getTimeZone;
        self.updateTimeZone = updateTimeZone;
        self.meetingCode = meetingService.getMeetingCode();
        self.brandingLogo = '';

        self.refresh = refresh;
        self.checkMeetingStatus = checkMeetingStatus;
        self.checkMeetingStatusTimeout = null;
        self.showCamaroDetector = false;
        self.isEnLocale = true;

        self.setupCheckMeetingStatusTimeout = setupCheckMeetingStatusTimeout;
        self.stopCheckMeetingStatusTimeout = stopCheckMeetingStatusTimeout;
        self.showProgress = showProgress;

        self.getStartMeetingUrl = getStartMeetingUrl;

        self.notifyWhenMeetingStarts = false;
        self.onNotifyBtnClicked = onNotifyBtnClicked;
        self.failedToLaunchApp = false;
        self.showNotifyMeButton = showNotifyMeButton;
        self.addHostLoginBlock = false;
        self.loginToStartScheduledMeeting = loginToStartScheduledMeeting;
        self.getMaxCharLength = getMaxCharLength;
        self.canJoinBeforeHost = canJoinBeforeHost;
        self.joinBeforeHost = joinBeforeHost;

        self.meetingNotStarted = true;
        self.skipJoinBeforeHost = $stateParams.data?.skipJoinBeforeHost;

        $scope.$on('camaro-detection-state-updated', detectionStateUpdated);

        init();

        ////////////////////////

        function init() {
            logger.log('init', 'start init');

            //jquery hack for hiding the loading spinner during XHR requests
            $window.$('body > #loading-bar-spinner').hide();

            self.setupCheckMeetingStatusTimeout();

            self.title = meetingService.getTitle();

            self.isEnLocale = localizationService.isEnLocale();

            if (!helperService.isUniteApplication() && !(brandingService.isUB() && !self.isEnLocale)) {
                self.addHostLoginBlock = true;
            }
            self.meetingURL = self.getStartMeetingUrl();

            initTimezoneData();
            setupBrandingLogo();

            self.showCamaroDetector = shouldUseCamaro();
        }

        function setupBrandingLogo() {
            var meetingCodeWithoutDashes = self.meetingCode.replace(/-/g, '');
            meetingAPIService.getBrandingInfo({ meetingCode: meetingCodeWithoutDashes }).then(
                function (brandingInfo) {
                    if (brandingInfo && brandingInfo.logoURL) {
                        self.brandingLogo = brandingInfo.logoURL;
                    }
                },
                function (err) {
                    logger.error('setupBrandingLogo', 'Error in getBrandingInfo', err);
                }
            );
        }

        function joinBeforeHost(meeting, deferred) {
            logger.log('joinBeforeHost', 'Starting to try join meeting before host');

            const data = { hashedPassword: helperService.getQueryParameter('pwd') };
            meetingAPIService
                .joinBeforeHost(meeting.meetingCode, data)
                .then(result => {
                    logger.log('joinBeforeHost', 'Successfully joined meeting before host', result);

                    if (!result.meetingWasActiveAlready) {
                        analyticsWrapperService.eventTrack('Meeting - JoinBeforeHost - StartedByAttendee');
                    }

                    deferred.resolve({ shouldRefresh: true });
                })
                .catch(error => {
                    logger.error('joinBeforeHost', 'Failed to join meeting before host', error);

                    switch (error.message) {
                        case 'skipJoinBeforeHost':
                            self.skipJoinBeforeHost = true;
                            break;
                        case 'serverError':
                            ++self.joinBeforeHostAttemptCounter;
                            break;
                        default:
                            break;
                    }

                    deferred.resolve({ shouldRefresh: false });
                });
        }

        function checkMeetingStatus() {
            var deferred = $q.defer();

            logger.log('checkMeetingStatus', 'calling api.getMeetingDetails to check meeting status...');

            //We just need to know if meeting is active or inactive...
            //Any potentially caught errors are irrelevant
            meetingAPIService
                .getMeetingDetails()
                .then(meeting => {
                    logger.log('checkMeetingStatus', 'got meeting details', meeting);

                    if (!meeting) {
                        deferred.resolve({ shouldRefresh: false });
                        return;
                    }

                    if (meeting.meetingStarted) {
                        // Meeting started and currently active
                        // OR
                        // Meeting started but already ended
                        deferred.resolve({ shouldRefresh: true });
                        return;
                    }

                    // Meeting scheduled but not yet started
                    if (self.canJoinBeforeHost(meeting)) {
                        self.joinBeforeHost(meeting, deferred);
                    } else {
                        logger.log('checkMeetingStatus', 'Cannot join meeting before host');

                        deferred.resolve({ shouldRefresh: false });
                    }
                })
                .catch(err => {
                    logger.error('checkMeetingStatus', 'error when get meeting details', err);
                    //Invalid meeting code
                    deferred.resolve({ shouldRefresh: false });
                });

            return deferred.promise;
        }

        function canJoinBeforeHost(meeting) {
            if (meeting.requiresPassword && !helperService.getQueryParameter('pwd')) {
                return false;
            }

            const authToken = authService.getAuthToken();

            return (
                !!authToken &&
                meeting.allowJoinBeforeHost &&
                !self.skipJoinBeforeHost &&
                self.joinBeforeHostAttemptCounter < maxJoinBeforeHostAttemptCount
            );
        }

        function setupCheckMeetingStatusTimeout() {
            logger.log('setupCheckMeetingStatusTimeout', 'Setup timeout for check meeting status');

            if (self.checkMeetingStatusTimeout) {
                logger.error('setupCheckMeetingStatusTimeout', 'Check meeting status timeout already initialized');
                return;
            }

            self.checkMeetingStatusTimeout = $timeout(function () {
                logger.log('setupCheckMeetingStatusTimeout', 'inside timeout');

                self.stopCheckMeetingStatusTimeout();

                self.checkMeetingStatus()
                    .then(function (resp) {
                        logger.log(
                            'setupCheckMeetingStatusTimeout',
                            `after checkMeetingStatus (self.notifyWhenMeetingStarts = ${self.notifyWhenMeetingStarts})`,
                            resp
                        );

                        if (resp && resp.shouldRefresh) {
                            //Doing a full page refresh will allow the original init flow/checks to happen
                            //Before sending user to the meeting login page
                            self.refresh();
                        } else {
                            self.setupCheckMeetingStatusTimeout();
                        }
                    })
                    .catch(function (err) {
                        logger.error('setupCheckMeetingStatusTimeout', 'error when check meeting status', err);

                        self.setupCheckMeetingStatusTimeout();
                    });
            }, 10 * 1000);
        }

        function stopCheckMeetingStatusTimeout() {
            logger.log(
                'stopCheckMeetingStatusTimeout',
                'Stopping check meeting status timeout',
                self.checkMeetingStatusTimeout
            );

            if (self.checkMeetingStatusTimeout) {
                $timeout.cancel(self.checkMeetingStatusTimeout);
                self.checkMeetingStatusTimeout = null;
            }
        }

        function refresh() {
            logger.log('refresh', 'Refreshing page...');
            $window.location.href = helperService.getUrlWithChimeQueryString();
        }

        function getStartMeetingUrl() {
            var code = meetingService.getMeetingCode();

            if (attendeeService.getIsHost()) {
                return helperService.getAccountManagerRedirectUrl('StartMeeting.aspx?code=' + code);
            }

            return helperService.getAccountManagerPassThroughUrl('/AccountManager/StartMeeting.aspx?code=' + code);
        }

        function initTimezoneData() {
            self.timeZoneList = timeZoneService.getTZList();

            var timeZoneId = meetingService.getTimeZoneId();
            if (!timeZoneId) {
                var rawTimeZone = meetingService.getTimeZone();
                self.creationTimezone = timeZoneService.convertToTimezoneObj(rawTimeZone);
            } else {
                self.creationTimezone = timeZoneId;
            }

            $window.moment.tz.setDefault(self.creationTimezone);

            var attendeeLocalTimeZone = timeZoneService.getLocalTimeZone();
            logger.log('initTimezoneData', 'Defined user local timezone', attendeeLocalTimeZone);
            var tzCache = cookieService.getObject('tzCache');

            //If 'show in my timezone' was already selected for this meeting, use that
            //Otherwise, use client's local timezone
            if (tzCache && self.getTimeZone(tzCache.timeZone)) {
                logger.log('initTimezoneData', 'Using timezone from cache', tzCache.timeZone);
                self.timeZoneSelected = tzCache.timeZone;
            } else {
                self.timeZoneSelected = attendeeLocalTimeZone;
            }

            self.updateTimeZone();
        }

        function updateTimeZone() {
            logger.log('updateTimeZone', 'Selected Timezone: ' + self.timeZoneSelected);

            var tzObj = self.getTimeZone(self.timeZoneSelected);

            if (!tzObj) {
                tzObj = self.timeZoneList[17]; //'America/Los_Angeles'
                self.timeZoneSelected = tzObj.tz;
            }

            self.timeZone = tzObj.name.substring(12, tzObj.name.length); //Splice (GMT-XX:XX) from name
            self.timeZoneShort = self.timeZone;

            if (self.timeZoneShort.length > 14) {
                self.timeZoneShort = self.timeZone.slice(0, 13) + '...';
            }

            var rawDate = meetingService.getDate();
            self.date = $window.moment(rawDate).tz(self.timeZoneSelected).format('dddd, MMMM DD, YYYY');

            var rawStartTime = meetingService.getStartTime();
            self.startTime = $window.moment(rawStartTime).tz(self.timeZoneSelected).format('hh:mma');

            var rawEndTime = meetingService.getEndTime();
            self.endTime = $window.moment(rawEndTime).tz(self.timeZoneSelected).format('hh:mma');

            var rawUpcomingEventTimes = meetingService.getUpcomingEventTimes();
            if (rawUpcomingEventTimes !== null && rawUpcomingEventTimes.length > 0) {
                for (var i = 0; i < rawUpcomingEventTimes.length; i++) {
                    var date = $window
                        .moment(rawUpcomingEventTimes[i])
                        .tz(self.timeZoneSelected)
                        .format('dddd, MMMM DD, YYYY');
                    self.upcomingEventTimes.push(date);
                }
            }

            var tzCache = {
                timeZone: self.timeZoneSelected
            };
            cookieService.putObject('tzCache', tzCache);

            //Store as cookie and reset to default dropdown option
            self.timeZoneSelected = '';
        }

        function getTimeZone(tz) {
            for (i = 0; i < self.timeZoneList.length; i++) {
                if (self.timeZoneList[i].tz === tz) {
                    return self.timeZoneList[i];
                }
            }

            return false;
        }

        function onNotifyBtnClicked() {
            logger.log('onNotifyBtnClicked', 'Notify when meeting starts');

            self.notifyWhenMeetingStarts = true;

            // We play this on user interaction to drive up the browser engagement,
            // which will then allow the audio notification chime to be autoplayed when a meeting is started.
            // Notify button cannot be removed from future design since user interaction is required to play audio notification chime.
            audioFileService.playEmptyAudio();
        }

        function detectionStateUpdated(e, data) {
            self.failedToLaunchApp = data === 'failed';
            if (self.failedToLaunchApp && helperService.isChrome()) {
                self.showCamaroDetector = shouldUseCamaro();
            }

            if (shouldShowClientNotSupported()) {
                routerService.setAppOrBrowserNotSupportedState();
            }
        }

        function shouldShowClientNotSupported() {
            return (
                helperService.isCamaroRetireEnabled(brandingService.getResellerCode()) &&
                !helperService.isSupportedClient()
            );
        }

        function shouldUseCamaro() {
            var meetingInfo = $stateParams.data?.meetingInfo || { launchApp: false };
            var launchApp = !helperService.isChrome() || meetingInfo.launchApp;
            return helperService.shouldUseCamaro() && launchApp && !self.failedToLaunchApp;
        }

        function showNotifyMeButton() {
            return !self.showCamaroDetector && !self.notifyWhenMeetingStarts;
        }

        function showProgress() {
            return !(helperService.shouldUseCamaro() && !helperService.isChrome()) && self.notifyWhenMeetingStarts;
        }

        function loginToStartScheduledMeeting() {
            logger.log(
                'loginToStartScheduledMeeting',
                'meetingNotStarted - Login to start scheduled meeting - button clicked'
            );
            if (helperService.isNotAuthenticatedUniteApplication()) {
                $window.preloadedApi.remote.ipcRenderer.sendAuthorizationRequest();
            } else {
                $window.location.href = self.meetingURL;
            }
        }

        function getMaxCharLength() {
            return self.timeZoneShort.length + 4;
        }
    }
]);
